import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import Row from '../../../../components/NotesPage/Table/Row';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		notes,
		notes: { currentStatus },
	} = state;
	const {
		title,
		date,
		modifiedOn,
		hasImage,
	} = notes[currentStatus][ownProps.id];

	return {
		title,
		date,
		modifiedOn,
		hasImage,
	};
};

export default connect(mapStateToProps)(Row);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/NotesPage/Table/Row/index.tsx